import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { VideoSection } from '../components/VideoSection';
import { Benefits } from '../components/Benefits';
import { BusinessModel } from '../components/BusinessModel';
import { Calculator } from '../components/Calculator';
import { About } from '../components/About';
import { Testimonials } from '../components/Testimonials';
import { GoogleReviews } from '../components/GoogleReviews';
import { Faq } from '../components/Faq';
import { NextStep } from '../components/NextStep';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { faqs } from '../data/content';
import { useSeo } from '../hooks/useSeo';
const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [{
    '@type': 'Organization',
    '@id': 'https://www.hotsalesgirls.com/#organization',
    name: 'Hot Sales Girls Academy',
    url: 'https://www.hotsalesgirls.com/',
    logo: 'https://cdn.magicpatterns.com/uploads/tNLTDY1fCXiQ1zp6ggV3Ei/hot-sales-girls-academy-logo.webp',
    description: 'Online-Academy für Frauen, die als Hot Sales Girl im Remote Sales starten und hochpreisige Angebote authentisch verkaufen möchten.',
    sameAs: ['https://www.instagram.com/tina_xla/', 'https://www.tiktok.com/@tina_xla', 'https://www.youtube.com/@tina_xla']
  }, {
    '@type': 'Course',
    name: 'Hot Sales Girls Academy',
    description: 'In 8 Wochen zum Hot Sales Girl: Verkaufsgespräche auf Augenhöhe führen, hochpreisige Angebote abschließen und ortsunabhängig arbeiten – auch ohne Vorkenntnisse.',
    inLanguage: 'de',
    provider: {
      '@id': 'https://www.hotsalesgirls.com/#organization'
    },
    hasCourseInstance: {
      '@type': 'CourseInstance',
      courseMode: 'online',
      courseWorkload: 'P8W'
    }
  }, {
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  }]
};
export function Home() {
  useSeo({
    title: 'Hot Sales Girl werden in 8 Wochen | Hot Sales Girls Academy',
    description: 'Lerne als Quereinsteigerin, hochpreisige Angebote authentisch zu verkaufen: 500–1.500€ Provision pro Abschluss, ortsunabhängig arbeiten und ohne eigenes Produkt starten. Jetzt kostenlosen Guide sichern.',
    path: '/'
  }, structuredData);
  return <div className="min-h-screen w-full overflow-x-hidden" data-id="element-567" data-mp="1tlf18a5xkerd">
      <div className="pink-panel relative" data-id="element-568" data-mp="1tkvs9iy9d0ph">
        <div className="relative z-10" data-id="element-569" data-mp="1yk8imdoc8pwt">
          <Navbar data-id="element-570" data-mp="1yj72vvwdnf8r" />
          <main data-id="element-571" data-mp="1yinim8j98erk">
            <Hero data-id="element-572" data-mp="1yi5hoylndcdb" />
            <VideoSection data-id="element-573" data-mp="2macgs5irbxgf" />
            <Benefits data-id="element-574" data-mp="2m91eka4ymxrf" />
            <div className="defer-paint" data-id="element-575" data-mp="2m8ro6lg06ol7">
              <BusinessModel data-id="element-576" data-mp="2r0j7qc0qru1u" />
            </div>
            <div className="defer-paint" data-id="element-577" data-mp="2r2dpxikmp828">
              <About data-id="element-578" data-mp="fltz4vddfqe4" />
            </div>
            <div className="defer-paint" data-id="element-579" data-mp="fkiz96n1r2sa">
              <Calculator data-id="element-580" data-mp="fjhci4wo4ruq" />
            </div>
            <div className="defer-paint" data-id="element-581" data-mp="alo6bbvd7xug">
              <Testimonials data-id="element-582" data-mp="akmsx0qvmz9k" />
            </div>
            <GoogleReviews data-id="element-583" data-mp="oedsbgaw92rk" />
            <div className="defer-paint" data-id="element-584" data-mp="odm9l62eazip">
              <Faq data-id="element-585" data-mp="kcir0bsyqpds" />
            </div>
            <div className="defer-paint" data-id="element-586" data-mp="kdll0sll17xx">
              <NextStep data-id="element-587" data-mp="ken4nlgnz2r9" />
            </div>
          </main>
          <Footer data-id="element-588" data-mp="3stdotcuwljl0" />
        </div>
      </div>
      <CookieBanner data-id="element-589" data-mp="3su6v6cpya72m" />
    </div>;
}